var elem = document.querySelector('.carousel');

if (elem) {
    var flkty = new Flickity(elem, {
        wrapAround: true,
    });
}
